export default {"src":"/_next/static/media/logo-lodz-colour.1c88e2cc.svg","height":56,"width":40};